import cx from "classnames";
import { themeTextColors } from "@common/constants";
import { Typography } from "@earned/core";
import { FC, ReactNode } from "react";
import { HiStar } from "react-icons/hi";

interface InputLabelProps {
  required?: boolean;
  value: ReactNode;
}

const InputLabel: FC<InputLabelProps> = ({ required, value }) => {
  return (
    <label className="mb-1 flex h-6 w-full flex-row items-center" htmlFor="">
      <div
        className={cx(
          "line-clamp-1 flex flex-1 flex-row items-center",
          value ? "" : "hidden"
        )}
      >
        <Typography
          variant="body-sm"
          color="primary"
          className="line-clamp-1 break-all text-input-label"
        >
          {value}
        </Typography>
        {required ? (
          <HiStar
            className="mb-1 flex h-[20px] w-[7px] flex-none"
            color={themeTextColors.danger}
          />
        ) : (
          <Typography variant="body-sm" color="secondary" className="ml-2">
            optional
          </Typography>
        )}
      </div>
    </label>
  );
};

export default InputLabel;
